import React, { useEffect, useState } from 'react';
import { Fade } from '@material-ui/core';
import Routes from 'routes';
import defaultLocales from 'globals/locales/default';
import { useAsyncWait } from 'globals/hooks/useAsyncWait';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import { useAppContext } from 'contexts/AppContext';
import { isSuccessState } from 'globals/utils';
import FsDefaultFallbackComponent from 'ui-elements/loaders/FsDefaultFallbackComponent';
import LeaderList from './LeaderList';

const Leaderboard: React.FC = () => {
  const {
    leaderboardList: { status, getRecentLeaderboardListItems, init: initStore },
  } = useAppContext();
  const [inStatus, setInStatus] = useState<boolean>(false);
  const linkDetails = { label: defaultLocales.seeAll, url: Routes.LEADERBOARD };

  useAsyncWait(setInStatus, 1200);

  useEffect(() => {
    initStore();
  }, [initStore]);

  if (!isSuccessState(status))
    return (
      <FsDefaultFallbackComponent
        status={status}
        data-test="default-fallback-component"
      />
    );

  return (
    <Fade in={inStatus} timeout={1000}>
      <FsPaper title={defaultLocales.leaderboard} link={linkDetails}>
        <LeaderList leaders={getRecentLeaderboardListItems()} />
      </FsPaper>
    </Fade>
  );
};

export default Leaderboard;
